import React, { useState } from "react";
import { Button, TextField, Theme } from "@material-ui/core";
import { navigate } from "@reach/router";
import { makeStyles } from "@material-ui/styles";
import { useFetcher, useResetter } from "rest-hooks";
import { LoginResource } from "../../../resources";

const useStyles = makeStyles((theme: Theme) => ({
	rootDiv: {
		position: "absolute",
		top: 8,
	}
}));

export const SsnImpersonaterTextField = () => {
	const [ssnInput, setSsnInput] = useState("");

	const classes = useStyles();

	const updateAdminImpersonation = useFetcher(LoginResource.impersonateShape());
	const cacheResetter = useResetter();

	const handleClick = () => {
		setSsnInput("");
		updateAdminImpersonation({}, { impersonatedSsn: ssnInput });
		cacheResetter();
		navigate("/");

	}

	return (
		<div id="ssnimpersonater" className={classes.rootDiv}>
			<Button onClick={handleClick}>Nullstill</Button>
			<TextField value={ssnInput} onChange={e => setSsnInput(e.target.value)} variant="filled" style={{height: 36}} />
			<Button onClick={handleClick}>Etterlikn</Button>
		</div>
	)
}
